import React from "react";

const MMIcon = () => (
  <div
    style={{
      backgroundColor: "#e0e0e0", // light gray
      color: "#0d6efd",           // blue
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      fontSize: "1.25rem",
      letterSpacing: "1px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      padding: "1.5rem",
    }}
  >
    MM
  </div>
);

export default MMIcon;
